import React from "react";
import PropTypes from "prop-types";
import ProductCard from "./ProductCard";

import { useTranslation } from "react-i18next";

/**
 * ProductGrid Molecule - Grid layout for displaying products
 * @component
 * @example
 * <ProductGrid
 *   products={filteredProducts}
 *   onSearchTextChange={handleSearchChange}
 *   scrollTargetRef={targetRef}
 *   variant="search"
 * />
 */
const ProductGrid = ({
  products,
  onSearchTextChange,
  scrollTargetRef,
  variant = "search",
  className = "",
}) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language.split("-")[0].toLowerCase();

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div
      className={`flex flex-wrap items-end justify-evenly pb-52 xl:w-full xl:justify-center sm:justify-evenly ${className}`}
    >
      {products.map((product, idx) => {
        const displayTitle = (currentLang === "de" && product.translations?.DE?.title)
          ? product.translations.DE.title
          : product.title;

        return (
          <ProductCard
            key={product._id}
            containerClassName="products-mini-contain"
            containerRef={idx === 0 ? scrollTargetRef : null}
            variant={variant}
            id={product._id}
            opId={product.opId}
            title={displayTitle}
            image={product.img}
            url={product.link}
            price={product.price}
            country={product.country}
            description={product.description}
            explanation={product.explanation}
            lovemeter={product.loveMeter}
            rank={product.rank}
            categories={product.categories}
            categoriesTranslated={product.categoriesTranslated}
            handleSearchTextChange={onSearchTextChange}
          />
        );
      })}
    </div>
  );
};

ProductGrid.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      img: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      country: PropTypes.string,
      loveMeter: PropTypes.number,
      categories: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  onSearchTextChange: PropTypes.func,
  scrollTargetRef: PropTypes.object,
  variant: PropTypes.oneOf(["search", "event"]),
  className: PropTypes.string,
};

export default ProductGrid;
